<template>
  <div>
    <el-form
      :model="propForm"
      ref="detailForm"
      label-position="top"
      :rules="formRules"
    >
      <el-row v-if="isHideAdjust">
        <el-col :span="16">
          <el-form-item :label="listTitle" :prop="targetKey">
            <el-select v-model="propForm[targetKey]">
              <el-option v-for="(item, idx) in targetList" :label="item.name" :key="idx" :value="item.id || item.uuid"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="!isHidePicker" :gutter="20">
        <el-col :span="12" >
          <el-form-item :label="$locale('memberShip.log.expiredTime')">
            <el-checkbox :value="!propForm.expireTimeLimit" @change="toggleLimited">期限なし</el-checkbox>
            <CommDatePicker
              v-if="propForm.expireTimeLimit"
              v-model="propForm.expireTime"
              :value.sync="propForm.expireTime"
              width="100%" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="!isHideAdjust" class="adjustPoint">
        <el-col :span="12" >
          <el-form-item :label="$locale('membership.detail.form.points')" prop="point">
            <el-input v-model="propForm.point" :placeholder="$locale('global.example') + '+100 / -10'">
              <template slot="prepend">Pt</template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="16">
          <el-form-item :label="$locale('global.remarks')" >
            <el-input v-model="propForm.remark" type="textarea" :rows="5" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row :gutter="20" type="flex" justify="center" style="margin-top: 37px;">
     <el-col :span="16" style="display: flex; justify-content: space-around;">
       <template>
         <el-button class="egl-btn-white" style="width: 250px;" @click="$emit('close')">
           {{ $locale("global.cancel") }}
         </el-button>
         <el-button class="egl-btn-yellow" style="width: 250px;background-color: rgba(249, 218, 73, 0.5);" @click="validateSave">
           {{ $locale("global.save") }}
         </el-button>
       </template>
     </el-col>
    </el-row>
  </div>
</template>
<script>
import CommDatePicker from "@/components/common/CommDatePicker";
import inventoryChangeQtyValidator from "@/utils/inventoryChangeQtyValidator";

export default {
  data() {
    return {
      formRules: {
        memberShipId: [
          {
            required: true, message: "付与する会員種類を選択してください", trigger: "change"
          }
        ],
        couponId: [
          {
            required: true, message: "付与する優待券を選択してください", trigger: "change"
          }
        ],
        point: [
          {
            required: true,
            message: this.$locale("shop.plsEnterNumOfFluctuations"),
            trigger: "blur",
          },
          {
            validator: inventoryChangeQtyValidator,
            trigger: "blur",
          }
        ]
      },
    };
  },
  methods: {
    validateSave() {
      const _this = this;
      this.$refs.detailForm.validate(valid => {
        if (valid) {
          _this.$emit("save");
        } else {
          setTimeout(() => {
            const isError = document.getElementsByClassName("is-error");
            isError[0].querySelector("input").focus();
          }, 100);

          return false;
        }
      });
      this.$emit('close');
    },
    toggleLimited(val) {
      this.propForm.expireTimeLimit = !val;
    }
  },
  props: {
    isShowCheckBox: {
      type: Boolean,
      default: false,
    },
    propForm: {
      type: Object,
      default: () => {}
    },
    targetList: {
      type: Array,
      default: () => []
    },
    targetKey: {
      type: String,
      default: () => ""
    },
    isHidePicker: {
      type: Boolean,
      default: () => false
    },
    isHideAdjust: {
      type: Boolean,
      default: () => true
    },
    listTitle: {
      type: String,
      default: () => ""
    }
  },
  components: {
    CommDatePicker
  }
};
</script>